var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcon3NuQa = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 12.423c0-.765.644-1.385 1.434-1.385h11.22c.794 0 1.437.62 1.437 1.385v6.51c0 .765-.643 1.386-1.437 1.386H10.02L8.35 22l-1.422-1.68H5.434c-.79 0-1.434-.622-1.434-1.387v-6.51z",
    stroke: "#1E2969",
    strokeWidth: 1.2,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 16.506C26 17.33 25.245 18 24.312 18h-1.76l-1.672 1.806L18.913 18H11.1c-.934 0-1.69-.67-1.69-1.494V9.492C9.41 8.67 10.167 8 11.1 8h13.212C25.245 8 26 8.669 26 9.492v7.014z",
    fill: "#1E2969"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcon3NuQa);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-3nu-qa.c63f1b18ec28f13e96df29a11763d15a.svg";